import { parseDate } from '@internationalized/date';
import { AxiosError } from 'axios';
import useSWRImmutable from 'swr/immutable';

import {
  parseDates,
  PaymentMethodT,
  WithStatusT,
} from '@consumer-frontend/nc-utils';

import {
  apiEndpoints,
  QueryParamsT,
} from '../lib';

type PaymentCalendarDatesResponseT = {
  invalid_dates: string[]; // ISO 8601 (YYYY-MM-DD)
  max_date: string; // ISO 8601 (YYYY-MM-DD)
  min_date: string; // ISO 8601 (YYYY-MM-DD)
};

export const usePaymentCalendarDates = (
  accountId?: string,
  loanNumber?: string,
  paymentMethod?: PaymentMethodT,
) => {
  const {
    data,
    error,
    isLoading,
  } = useSWRImmutable<WithStatusT<PaymentCalendarDatesResponseT>, AxiosError>(
    () => {
      const queryParams: QueryParamsT = {};

      if (paymentMethod) { queryParams.payment_method = paymentMethod; }

      if (!accountId || !loanNumber) { return null; }

      return apiEndpoints.dashboard.paymentCalendarDates(accountId, loanNumber, queryParams);
    },
  );

  return {
    error,
    isLoading,
    paymentCalendarDates: data
      ? {
        invalidDates: parseDates(data.invalid_dates),
        maxDate: parseDate(data.max_date),
        minDate: parseDate(data.min_date),
      }
      : undefined,
    status: data?.status || error?.status,
  };
};
